/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S10_HeadingInputs */

const tr_iade_iptal_s10_heading = /** @type {(inputs: Iade_Iptal_S10_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Veri İhracı (Data Export) ve Taşınabilirlik`)
};

const en_iade_iptal_s10_heading = /** @type {(inputs: Iade_Iptal_S10_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Data Export and Portability`)
};

const de_iade_iptal_s10_heading = /** @type {(inputs: Iade_Iptal_S10_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Datenexport (Data Export) und Übertragbarkeit`)
};

const ru_iade_iptal_s10_heading = /** @type {(inputs: Iade_Iptal_S10_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10. Экспорт данных (Data Export) и переносимость`)
};

/**
* | output |
* | --- |
* | "10. Data Export and Portability" |
*
* @param {Iade_Iptal_S10_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s10_heading = /** @type {((inputs?: Iade_Iptal_S10_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S10_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s10_heading(inputs)
	if (locale === "de") return de_iade_iptal_s10_heading(inputs)
	if (locale === "ru") return ru_iade_iptal_s10_heading(inputs)
	return tr_iade_iptal_s10_heading(inputs)
});